import styles from "./MarathonCtaSection.module.css";
import {MyButton} from "../../../common";
import {ButtonIcon, ButtonSecondIcon} from "../MarathonHeroSection";
import firstImage from "../../../../assets/images/pages/ParentsMarathon/section-7-birds.png"
import { useEmbeddedNavigate } from "../../../../utils/context/embed";
import { ConsultationFormModal } from "../../../popups/ConsulationPopup/ConsultationPopup";
import { useState } from "react";
import { COOKIE_KEY, RootState, selectStore } from "../../../../utils";
import { useSelector } from "react-redux";
import {Cookies} from "react-cookie";

export const MarathonCtaSection = () => {
  const embeddedNavigate = useEmbeddedNavigate();
const [isModalVisible, setIsModalVisible] = useState(false);
  const [canSelectSpecialist, setCanSelectSpecialist] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const { profile: { userData: userDataState, specialistsData: specialistsState}}: RootState = useSelector(selectStore);
  const cookies = new Cookies()
  const specialists = Array.isArray(specialistsState?.data)
  ? specialistsState.data
  : [];
  let token = cookies.get(COOKIE_KEY.ACCESS_TOKEN);
  const showModal = () => {
    console.log("showModal вызван");
    setIsModalVisible(true);
    setCanSelectSpecialist(true);
  };

  const handleOk = () => setIsModalVisible(false);
  const handleCancel = () => {
    setIsModalVisible(false);
    setCanSelectSpecialist(false);
  };

  return (
    <section className={styles.section} aria-label="Начните помогать ребёнку">
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>
            Начните помогать ребёнку
            <br />
            говорить уже сегодня!
          </h2>

          <p className={styles.subtitle}>
            Вы можете начать с простых шагов —
            <br />и увидеть результат уже в первые недели.
          </p>

          <div className={styles.buttons}>
            <MyButton color="orange" type="primary" onClick={() => embeddedNavigate("/diagnostics-marathon")}>
              Начать марафон <ButtonIcon />
            </MyButton>


            <MyButton color="blue" type="primary" onClick={() => {
                            if (token) {
                              if (userDataState?.data?.first_name && userDataState?.data?.last_name && userDataState?.data?.region_id) {
                                showModal();
                              } else {
                                embeddedNavigate('/register/confirm');
                              }
                            } else {
                              embeddedNavigate('/auth');
                            }
                          }}>
              Задать вопрос <ButtonSecondIcon />
            </MyButton>
          </div>
        </div>

        <img src={firstImage} alt="section-7-birds"/>
      </div>
      <ConsultationFormModal visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} specialists={specialists} selectedItem={selectedItem}  canSelectSpecialist={canSelectSpecialist}/>
      
    </section>
  );
};